import { LoanStatus } from 'domain/loan/enums';

import { CACHE_TAG } from 'enums';

import apiRoutes from 'router/routes/ApiRoutes';

import { apiContainer } from 'store';

import { selectResultsFromResponse } from 'utils/objects';
import { createTag } from 'utils/rtkQuery';

import { IExtendedLoan } from './types';

export const extendedLoanApi = apiContainer.injectEndpoints({
  endpoints: builder => ({
    getExtendedLoans: builder.query<IExtendedLoan, { status: LoanStatus }>({
      query: params => ({
        url: apiRoutes.loansExtendedListPath(),
        method: 'GET',
        params,
      }),
      transformResponse: selectResultsFromResponse,
      providesTags: result => createTag.index(result, CACHE_TAG.extendedLoan),
    }),
  }),
});

export const { useGetExtendedLoansQuery } = extendedLoanApi;
